import { findAcessoByLastFiveDays, findAcessoByAnoLetivo } from "./api-engajamento-diario";
import EngajamentoChart, {
  PERIODO_ANO_LETIVO,
  PERIODO_CINCO_DIAS,
  SERIES_COLORS,
} from "./EngajamentoChart";

const FETCHERS = {
  [PERIODO_CINCO_DIAS]: findAcessoByLastFiveDays,
  [PERIODO_ANO_LETIVO]: findAcessoByAnoLetivo,
};

const ultimo = (lista) => (lista && lista.length > 0 ? lista[lista.length - 1] : 0);

const getSeries = (data) => [
  { label: "Responsáveis", data: data.listaTotalResp ?? [], color: SERIES_COLORS.azul },
  { label: "Alunos", data: data.listaTotalAluno ?? [], color: SERIES_COLORS.laranja },
];

const getStats = (data) => {
  const dia = ultimo(data.listaAxeX);
  return [
    { label: "Responsáveis", value: ultimo(data.listaTotalResp), caption: `acessos em ${dia}` },
    { label: "Alunos", value: ultimo(data.listaTotalAluno), caption: `acessos em ${dia}` },
  ];
};

export default function Acesso() {
  return (
    <EngajamentoChart
      title="Acesso"
      description="Responsáveis e alunos que acessaram o sistema por dia."
      fetchers={FETCHERS}
      getSeries={getSeries}
      getStats={getStats}
    />
  );
}
